import React from 'react';
import TreatmentConsentLandingPage from './TreatmentConsentLandingPage';

export default function RootCanalConsentFormUk() {
  return (
    <TreatmentConsentLandingPage
      title="Root Canal Consent Form UK | Endodontic Consent | Smile Consent"
      description="Build a root canal consent form for UK practices with AI-assisted drafting, digital signing, and clearer records for risks, alternatives, and long-term prognosis."
      canonicalUrl="https://smileconsent.co.uk/root-canal-consent-form-uk"
      h1="Root Canal Consent Form for UK Practices"
      treatmentName="Root canal consent form"
      intro="Create root canal consent forms with clearer discussion of prognosis, alternatives, restoration needs, and digital signing for UK dental practices."
      risks={[
        'Diagnosis, reason for treatment, and the intended benefit of preserving the tooth where possible.',
        'Material risks such as persistent symptoms, instrument fracture, perforation, missed anatomy, need for re-treatment, or extraction if treatment fails.',
        'Alternatives including monitoring, extraction, referral to a specialist, or no treatment where appropriate.',
        'Need for final restoration, future fracture risk, and the possibility of additional treatment costs after endodontics.',
        'Expected recovery, review planning, and how the tooth will be monitored over time.',
      ]}
      relatedLinks={[
        { title: 'Tooth extraction consent form UK', description: 'Consent wording when extraction is the main alternative', path: '/tooth-extraction-consent-form-uk' },
        { title: 'Orthodontic consent form UK', description: 'Treatment-specific consent for orthodontic cases', path: '/orthodontic-consent-form-uk' },
        { title: 'AI dental consent forms', description: 'See all treatment-specific consent workflows', path: '/dental-consent-forms' },
      ]}
    />
  );
}
